import type { ResultType } from '@/pages/YangbokOrg/questionFormTypes';
import { HANBOK_RESULT_TYPES } from './hanbokResultTypes';
import { JEWELRY_RESULT_TYPES } from './jewelryResultTypes';
import { RESULT_TYPES as SUIT_RESULT_TYPES } from './yangbokResultTypes';

const DEFAULT_CATEGORY = 'suit';
const DEFAULT_RESULT_KEY_BY_CATEGORY: Record<string, string> = {
  suit: 'semiBespoke',
  yebok: 'semiBespoke',
  yangbok: 'semiBespoke',
  jewelry: 'customBand',
  yemul: 'customBand',
  hanbok: 'rentalValue',
};

export const CATEGORY_RESULT_TYPES: Record<string, ResultType[]> = {
  suit: SUIT_RESULT_TYPES,
  yebok: SUIT_RESULT_TYPES,
  yangbok: SUIT_RESULT_TYPES,
  jewelry: JEWELRY_RESULT_TYPES,
  yemul: JEWELRY_RESULT_TYPES,
  hanbok: HANBOK_RESULT_TYPES,
};

export function getResultTypesByCategory(category?: string) {
  return (
    (category && CATEGORY_RESULT_TYPES[category]) ||
    CATEGORY_RESULT_TYPES[DEFAULT_CATEGORY]
  );
}

export function getDefaultResultKeyByCategory(category?: string) {
  return (
    (category && DEFAULT_RESULT_KEY_BY_CATEGORY[category]) ||
    DEFAULT_RESULT_KEY_BY_CATEGORY[DEFAULT_CATEGORY]
  );
}

export function getResultByCategoryAndKey(
  category?: string,
  resultKey?: string,
) {
  const resultTypes = getResultTypesByCategory(category);
  const defaultResultKey = getDefaultResultKeyByCategory(category);

  return (
    resultTypes.find((item) => item.key === resultKey) ||
    resultTypes.find((item) => item.key === defaultResultKey) ||
    resultTypes[0]
  );
}
